class CreatineHeroGallery extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('.creatine-hero__gallery-track');
    if (!this._track) return;
    this._restartAnimation();
  }

  disconnectedCallback() {
    this._track = null;
  }

  _restartAnimation() {
    if (!this._track) return;
    // Force a reflow so the animation restarts from frame 0 after editor reloads
    this._track.style.animation = 'none';
    // eslint-disable-next-line no-unused-expressions
    this._track.offsetHeight;
    this._track.style.animation = '';
  }
}

if (!customElements.get('creatine-hero-gallery')) {
  customElements.define('creatine-hero-gallery', CreatineHeroGallery);
}

// Shopify Theme Editor: re-init when section settings or blocks change
document.addEventListener('shopify:section:load', (event) => {
  const gallery = event.target.querySelector('creatine-hero-gallery');
  if (gallery) gallery._restartAnimation();
});
